module.exports = __webpack_public_path__ + "img/westham-united.b9296ec2.png";